import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const GradientButton = ({title, isSelected, isBusy, onClick}) => {
  return (
    <div className="GradientButton">
      <button className={classNames(
        "GradientButton__button", {
          "GradientButton__button--selected": isSelected,
          "GradientButton--disabled": isBusy,
        })}
        onClick={onClick}
      >
        {
          // Wrap the button contents in a span because Safari does not allow
          // a button tag to be a flex container.
        }
        <span className="GradientButton__contents">
          <p className="GradientButton__title">
            {title}
          </p>
        </span>
      </button>
    </div>
  );
};

GradientButton.propTypes = {
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  isBusy: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isBusy: state.busy.isBusy,
});

export { GradientButton };
export default connect(mapStateToProps)(GradientButton);



// WEBPACK FOOTER //
// ./src/components/GradientButton.js